import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit } from '@angular/core';


import {
  Mitarbeiter,
  MitarbeiterService,
  StundeninfoService,
  Stundeninfo
} from '@proffix/restapi-angular-library';

import { UserSessionService, CustomProffixService, StundeninfoCache } from '../../services';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.css']
})
export class MaintenanceComponent implements OnInit {

  constructor(
    private _userSessionService: UserSessionService,
    private _activatedRoute: ActivatedRoute,
    private _customProffixService: CustomProffixService,
    private _mitarbeiterService: MitarbeiterService, ) {
  }

  ngOnInit() {
    // enable login by using query string parameters
    this._activatedRoute.queryParams.subscribe(params => {
      const job = params['job'];
      const doLogout = params['doLogout'];

      const postProcess = () => {
        if (doLogout != "0") {
          this._userSessionService.logout().subscribe(() => { });
        }
      };

      if (job) {
        switch (job) {
          case "cache_stundeninfo":
            this.runCacheStundeninfo(postProcess);
            break;

          default:
            break;
        }
      }
    });
  }

  private runCacheStundeninfo(onSuccess: () => void) {
    // get existing cached "Stundeninfo"
    this._customProffixService.getStundeninfoCache({ limit: 1000 }).subscribe(listOfExistingCache => {
      // get a list of all "Mitarbeiter"
      this._mitarbeiterService.getAll({ limit: 1000 }).subscribe((listOfMitarbeiter) => {
        // start the recoursive calculation of the "Stundeninfo"
        this.calculateNextCacheStundeninfo(listOfMitarbeiter, listOfExistingCache, () => {
          // finished with all "Mitarbeiter"
          onSuccess();
        });
      });
    });
  }



  private calculateNextCacheStundeninfo(listOfMitarbeiter: Mitarbeiter[], listOfExistingCache: StundeninfoCache[], onSuccess: () => void) {
    const now = new Date();

    if (listOfMitarbeiter.length == 0) {
      // finished with all "Mitarbeiter"
      onSuccess();
      return;
    }

    const nextMitarbeiter = listOfMitarbeiter.shift();

    this._customProffixService.getAllStundeninfo({
      mitarbeiter: nextMitarbeiter.MitarbeiterNr,
      datum: now.getDate() + '.' + (now.getMonth() + 1) + '.' + now.getFullYear(),
    }).subscribe((stundeninfo) => {
      var isNew = false;
      var cache = this.findStundeninfoCache(listOfExistingCache, nextMitarbeiter.MitarbeiterNr);

      if (!cache) {
        isNew = true;
      }

      cache = stundeninfo;
      cache.MitNrPRO = nextMitarbeiter.MitarbeiterNr;

      if (isNew) {
        this._customProffixService.postStundeninfoCache(cache).subscribe(() => {
          this.calculateNextCacheStundeninfo(listOfMitarbeiter, listOfExistingCache, onSuccess);
        });
      } else {

        this._customProffixService.putStundeninfoCache(cache).subscribe(() => {
          this.calculateNextCacheStundeninfo(listOfMitarbeiter, listOfExistingCache, onSuccess);
        });
      }
    });

  }

  private findStundeninfoCache(listOfExistingCache: StundeninfoCache[], mitNrPRO: number): StundeninfoCache {
    return listOfExistingCache.find((item) => {
      return item.MitNrPRO === mitNrPRO;
    });
  }
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/maintenance/maintenance.component.ts